
import type { MetadataEntity } from '../metadata-entity';

import { Property, PropertyMetadataMapper } from './property-metadata.decorator';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Unserializable(): PropertyMetadataMapper {
	return function(model: MetadataEntity, property: string): void {
		Property({ unserializable: true })(model, property);
	};
}
